import React from "react";

// cabeçalho padrão de cada tela do painel: título, descrição e ações à direita (empilham no mobile)
export default function AdminPage({ title, description, actions, children }: { title: React.ReactNode, description?: React.ReactNode, actions?: React.ReactNode, children: React.ReactNode }) {
    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
                <div className="min-w-0">
                    <h1 className="text-2xl md:text-[1.75rem] font-bold tracking-tight text-gray-900">{title}</h1>
                    {
                        description ?
                            <p className="mt-1 text-sm text-gray-500 max-w-2xl">{description}</p>
                            : null
                    }
                </div>
                {
                    actions ?
                        <div className="flex flex-wrap items-center gap-2">{actions}</div>
                        : null
                }
            </div>
            {children}
        </div>
    )
}
